import script from "./sf-button-ds.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-button-ds.vue?vue&type=script&setup=true&lang=ts"

import "./sf-button-ds.vue?vue&type=style&index=0&id=e96b44a6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e96b44a6"]])

export default __exports__